import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('product-buy-button')
class ProductBuyButton extends LitElement {
  constructor() {
    super();
    this.sizeSelected = false;
    this.classesToRemove = ['hidden', 'group-hover:hidden'];
  }

  connectedCallback() {
    super.connectedCallback();
    this.addToCartText = this.querySelectorAll('[data-add-to-cart-text]');
    this.selectVariantText = this.querySelectorAll(
      '[data-select-variant-text]',
    );
    this.atcSticky = this.querySelector('[data-atc-sticky]');
    this.atcStickyButton = this.querySelector('[data-sticky-atc-button]');
    this.atcStickyButton.addEventListener('click', this._handleStickyAtcClick);
    document.addEventListener('pdp:variant-change', this._handleVariantChange);
    this.observer = new IntersectionObserver(this._handleIntersection, {
      root: null,
      threshold: 0,
    });
    this.observer.observe(this);
  }

  _handleStickyAtcClick = () => {
    if (!this.sizeSelected) {
      document.querySelector('product-variant-selector').scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  disconnectedCallback() {
    document.removeEventListener(
      'pdp:variant-change',
      this._handleVariantChange,
    );
    this.atcStickyButton.removeEventListener(
      'click',
      this._handleStickyAtcClick,
    );
    this.observer.disconnect();
    super.disconnectedCallback();
  }

  _handleVariantChange = () => {
    this.sizeSelected = true;
    this.addToCartText.forEach((element) => {
      element.classList.remove(...this.classesToRemove);
    });
    if (this.selectVariantText) {
      this.selectVariantText.forEach((element) => {
        element.classList.add('!hidden');
      });
    }
  };

  _handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
        this.atcSticky.classList.remove('hidden');
      } else {
        this.atcSticky.classList.add('hidden');
      }
    });
  };

  render() {
    return html`<slot></slot>`;
  }
}

export default ProductBuyButton;
